import { useState } from "react";
import { useRecordContext, ArrayField, Datagrid, TextField, Button, SimpleShowLayout } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { settings } from "app";
import ProfessorField from "server/components/Fields/ProfessorField";
import ExaminationHeadsForm from "./ExaminationHeadsForm";

const ExaminationHeadsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  const record = useRecordContext();
  const [isEditing, setIsEditing] = useState(false);

  return (
    <SimpleShowLayout>
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        {isEditing ? (
          <Grid
            item
            xs={12}
          >
            <ExaminationHeadsForm
              record={record}
              setIsEditing={setIsEditing}
            />
          </Grid>
        ) : (
          <>
            <Grid
              item
              xs={12}
              md={6}
            >
              <ArrayField
                source="examinationHeads"
                label=""
              >
                <Datagrid
                  bulkActionButtons={false}
                  sx={settings.style.detailsDatagrid}
                >
                  <ProfessorField
                    source="employeeId"
                    label="Преподавател"
                  />
                  <TextField
                    source="externalEmployeeNames"
                    label="Имена (външни)"
                  />
                </Datagrid>
              </ArrayField>
            </Grid>
            <Grid
              item
              xs={12}
            >
              <SecuredComponent permission={permissions.canManageAdvancedSpecializationsExaminationHeads}>
                <Button
                  variant="contained"
                  startIcon={<EditIcon />}
                  label="Редактирай"
                  onClick={() => setIsEditing(v => !v)}
                />
              </SecuredComponent>
            </Grid>
          </>
        )}
      </Grid>
    </SimpleShowLayout>
  );
};

export default ExaminationHeadsSection;
